import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState, AppThunk } from "../../app/store";
import { fetchPolicyDetails } from "./ethicspolicydetailsAPI";

export interface PolicyState {
  policyDetail: any; 
  status: "idle" | "loading" | "failed" | "success";
}

const initialState: PolicyState = {
  policyDetail: {},
  status: "idle",
};

export const GetPolicyDetails = createAsyncThunk(
  "policyDetails/fetchPolicyDetails",
  async (data:any) => {
    const response = await fetchPolicyDetails(data);
    return response;
  }
);

export const policySlice = createSlice({
  name: "policyDetails",
  initialState,
  reducers: {},

  extraReducers: (builder) => {
    builder
      .addCase(GetPolicyDetails.pending, (state) => {
        state.status = "loading";
      })
      .addCase(GetPolicyDetails.rejected, (state) => {
        state.status = "failed";
      })
      .addCase(GetPolicyDetails.fulfilled, (state, action) => {
        state.status = "success";
        state.policyDetail = action.payload;
      });
  },
});

export const {} = policySlice.actions;

export const selectPolicyDetails = (state: RootState) => {
  return state.policyDetails.policyDetail;
};

export default policySlice.reducer;
